import { Box } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { YearlyCountStats } from "../IssueStats/YearlyCountStats";
import { TodoCountAnalytics_TodoStats$key } from "./__generated__/TodoCountAnalytics_TodoStats.graphql";

export function TodoCountAnalytics(props: {
  todoCountAnalytics: TodoCountAnalytics_TodoStats$key;
}) {
  const data = useFragment(
    graphql`
      fragment TodoCountAnalytics_TodoStats on TodoStats {
        created {
          date
          count
        }
        resolved {
          date
          count
        }
      }
    `,
    props.todoCountAnalytics
  );

  return (
    <Box spaceTop="small">
      <Box color="surface" spaceVertical="medium">
        <YearlyCountStats
          createdData={data.created}
          resolvedData={data.resolved}
        />
      </Box>
    </Box>
  );
}
